'use client';

import { Plus } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { cn } from '@/app/utils';

const FAQ_KEYS = ['faq1', 'faq2', 'faq3', 'faq4', 'faq5'] as const;
type FaqKey = (typeof FAQ_KEYS)[number];

export function LandingFaq() {
  const t = useTranslations('artistProgram.landing');
  const [openKey, setOpenKey] = useState<FaqKey | null>('faq1');

  return (
    <section className="relative px-24 py-[120px] sm:px-4 sm:py-16">
      <div className="mx-auto flex w-full max-w-[1728px] flex-col items-center gap-[91px] sm:gap-10">
        <h2 className="text-center font-semibold text-[48px] text-white leading-none sm:text-3xl">{t('faqTitle')}</h2>
        <div className="flex w-full flex-col gap-3">
          {FAQ_KEYS.map((key) => {
            const isOpen = openKey === key;
            return (
              <div key={key} className="rounded-16 bg-white/10 px-6 py-5 sm:px-4 sm:py-4">
                <button
                  type="button"
                  className="flex w-full items-start justify-between gap-4 text-left"
                  onClick={() => setOpenKey(isOpen ? null : key)}
                  aria-expanded={isOpen}
                >
                  <span className="font-medium text-base text-white leading-6 sm:text-sm sm:leading-5">
                    {t(`${key}Question`)}
                  </span>
                  <Plus
                    className={cn(
                      'mt-1 size-5 shrink-0 text-white transition-transform duration-200',
                      isOpen && 'rotate-45',
                    )}
                    aria-hidden="true"
                  />
                </button>
                {isOpen ? (
                  <p className="mt-3 text-white/56 text-xs leading-[1.5] sm:text-xs">{t(`${key}Answer`)}</p>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
